import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { userConnected: Boolean }
  }

  click(e) {
    e.preventDefault()

    let lang = e.target.getAttribute("lang")
    let target = e.target.getAttribute("href")

    if (this.userConnectedValue) {
      App.user.save(
        { preferred_locale: lang },
        {
          success: function () {
            // When signed in users browse the homepage, they are automatically redirected to /search.
            // So we need to redirect them to /home instead.
            if (target === "/" || target === `/${lang}`) {
              target = "/home"
            }

            window.location = target
          },
          error: function () {
            App.displayFlash(
              "danger",
              i18n.t("js.front.navigation.locale.failed_to_switch", { language: e.target.innerText }),
            )
          },
        },
      )
    } else {
      App.createCookie("locale", lang, null)
      window.location = target
    }
  }
}
